var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`${_vm.vista} in-iframe-${_vm.inIframe}`,attrs:{"id":"app"}},[_c('top-bar'),_c('div',{staticClass:"router-container"},[_c('wrap-container',{staticClass:"w100 router-container-inner"},[_c('router-view')],1),(!_vm.loading)?_c('app-footer'):_vm._e()],1),(_vm.loading)?_c('lottie-loader'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }